import { graphql } from 'react-relay';
export const ContentViewedEventQuery = graphql`
	query ContentViewedEventQuery($contentId: ID) {
		content(id: $contentId, trigger: "viewed") {
			nodes {
				id
			}
		}
	}
`;
